import { Injectable } from '@angular/core';
import { Http , Headers, RequestOptions, Response, Jsonp, URLSearchParams, ResponseContentType, ResponseType } from '@angular/http';
// import { User } from '../models/user';
import { AppConfig } from '../../app.config';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/switchMap';
import { Subject } from 'rxjs/Subject';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser'
// import {ResponseContentType} from "@angular/http/index";

@Injectable()
export class ProductService {
    constructor(private http: Http,
        private config: AppConfig,
        private _jsonp: Jsonp,
        private domSanitizer: DomSanitizer  ) { }
    saveProduct(product: any) {
        // tslint:disable-next-line: max-line-length
        return this.http.post(this.config.apiUrl + 'product/create', product, this.setHeaders()).map((response: Response) => response.json());
    }
    getAllProduct(productCurrentPage: number, maxSize: any, filter: any) {
        // tslint:disable-next-line: max-line-length
        return this.http.post(this.config.apiUrl + 'product/get-all?page=' + productCurrentPage + '&limit=' + maxSize, filter, this.setHeaders()).map((response: Response) => response.json());
    }
    getUserProduct(user_id: any) {
        // tslint:disable-next-line: max-line-length
        return this.http.post(this.config.apiUrl + 'product/get-all-product-type', {user_id: user_id}, this.setHeaders()).map((response: Response) => response.json());
    }
    addRemoveUserProduct(reqData) {
        // tslint:disable-next-line: max-line-length
        return this.http.post(this.config.apiUrl + 'product/add-remove-product', reqData, this.setHeaders()).map((response: Response) => response.json());
    }
    getAllActiveProductTypes() {
        // tslint:disable-next-line: max-line-length
        return this.http.get(this.config.apiUrl + 'product/get-all-product-type', this.setHeaders()).map((response: Response) => response.json());
    }
    getProductById(id: any) {
        // tslint:disable-next-line: max-line-length
        return this.http.post(this.config.apiUrl + 'product/get-by-id', { id: id }, this.setHeaders()).map((response: Response) => response.json());
    }
    getAllActiveProduct() {
        return this.http.get(this.config.apiUrl + 'product/get-all-active', this.setHeaders()).map((response: Response) => response.json());
    }
    // deleteProduct(id: any) {
    //      return this.http.post(this.config.apiUrl +'product/delete',id, this.setHeaders()).map((response: Response) => response.json());
    // }
    updateProduct(product: any) {
        // tslint:disable-next-line: max-line-length
        return this.http.put(this.config.apiUrl + 'product/update', product, this.setHeaders()).map((response: Response) => response.json());
    }
    paymentSalesRevertOffByAdmin(reqData: any) {
        return this.http.post(this.config.apiUrl + 'payment/update-payment-auto-sales-revert', reqData, this.setHeaders())
        .map((response: Response) => response.json());
    }
    updatePaymentMode(reqData: any) {
        return this.http.post(this.config.apiUrl + 'payment/update-payment-mode', reqData, this.setHeaders())
        .map((response: Response) => response.json());
    }
    downloadInvoice(invoice_no: any) {
        console.log('downloadInvoice service ' + this.config.apiUrl + 'product/invoice/' + invoice_no);
        // debugger;
        const token = localStorage.getItem('token');
        const headers = new Headers({
            'x-roamingse-token': token,
            'Accept': 'application/pdf',
        });
        const header = new RequestOptions({
            headers: headers,
            search: { invoiceNumber: invoice_no },
        });
        header.responseType = ResponseContentType.ArrayBuffer;

        return this.http.get(this.config.apiUrl + 'product/invoice', header).toPromise().then(data => {
            const mediaType = 'application/pdf';
            console.log(data['_body']);
            const blob = new Blob([data['_body']], { type: mediaType });
            const url = URL.createObjectURL(blob);
            const dwldLink = document.createElement('a');

            const disposition = data.headers.get('Content-Disposition');
            let filename;
            if (disposition && disposition.indexOf('attachment') !== -1) {
                const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                const matches = filenameRegex.exec(disposition);
                if (matches != null && matches[1]) {
                    filename = matches[1].replace(/['"]/g, '');
                }
            }
            dwldLink.setAttribute('href', url);
            dwldLink.setAttribute('download', filename);
            dwldLink.style.visibility = 'hidden';
            document.body.appendChild(dwldLink);
            dwldLink.click();
            document.body.removeChild(dwldLink);
        })
    }
    getChildProduct(type) {
        // tslint:disable-next-line: max-line-length
        return this.http.get(this.config.apiUrl + 'product/child-product?q=' + type, this.setHeaders()).map((response: Response) => response.json());
    }
    getSubProduct(id) {
        // tslint:disable-next-line: max-line-length
        return this.http.get(this.config.apiUrl + 'product/sub-product?id=' + id, this.setHeaders()).map((response: Response) => response.json());
    }
    private setHeaders(params?: any) {
        // create authorization header with jwt token
        const token = localStorage.getItem('token');
        if (token) {
            // console.log('token >>>' + token);
            const headers = new Headers({ 'x-roamingse-token': token });
            if (params) {
                return new RequestOptions({ headers: headers, search: params });
            } else {
                return new RequestOptions({ headers: headers });
            }
        } else {
            return new RequestOptions({});
        }
    }
}



// WEBPACK FOOTER //
// /home/ec2-user/jenkins/workspace/new-roamingse/prod/roamingse-frontend/src/app/shared/services/product.service.ts